import { useLocation } from "react-router";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import AuthComponent from "../../components/AuthComponent";
import { useState } from "react";

const headers = [
  {
    key: "name",
    name: "Name",
  },
  {
    key: "username",
    name: "Username",
  },
  {
    key: "phone1",
    name: "Phone",
  },
  {
    key: "status",
    name: "Status",
  },
];

export function OfficeUserList() {
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/user",
    defaultQuery: "status=ACTIVE",
  });

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({
        name: trimmed,
      });
    }else{
      setQuery({});
    }
  };

  const nothingFoundAfterSearch = 
    searchValue && Array.isArray(data?.results) && data.results.length === 0;
  return (
    <TableLayout
      title="Office User List"
      data={data}
      headers={headers}
      idKey="user_id"
      endPoint="/user"
      removeDetails={true}
      setCurrentPage={setCurrentPage}
      hasSearch
      hasCreate
      module="Office User"
      subModule="Office User List"
      hasReset
      createPath={`/office-user/create`}
      hasActions
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      reload={reload}
      setQuery={setQuery}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
}
